Flickity.createMethods.push('_createFade');

Flickity.prototype._createFade = function() {
  this.fadeIndex = 0;
  this.prevFadeIndex = 0;
  this.on('select', this.onSelectFade);
  this.on('dragEnd', this.onDragEndFade);
  this.on('settle', this.onSettleFade);
  this.on('activate', this.onActivateFade);
  this.on('deactivate', this.onDeactivateFade);
};

Flickity.prototype.onSelectFade = function() {
  this.fadeIndex = this.selectedIndex;
};

Flickity.prototype.onSettleFade = function() {
  delete this.didDragEnd;
  if (!this.options.fade) {
    return;
  }
  this.selectedElement.style.opacity = 1;
};

Flickity.prototype.onDragEndFade = function() {
  this.didDragEnd = true;
};

Flickity.prototype.onActivateFade = function() {
  if (this.options.fade) {
    this.element.classList.add('is-fade');
  }
};

Flickity.prototype.onDeactivateFade = function() {
  if (this.options.fade) {
    this.element.classList.remove('is-fade');
  }
};

